import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';

export default class DashboardUrlChartNewController extends Controller {
  queryParams = ['serpPreviewKeywordId'];

  @tracked serpPreviewKeywordId;
}
